<template>
  <table class="table table-striped">
    <thead>
      <tr>
        <th>日付／担当医</th>
        <th>処置内容</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="row in yobouLog"
        :key="row.rabies_id"
      >
        <td class="index">
          <div class="date">{{row.prevention_date}}</div>
          <div class="doctor">{{row.carryout_prevention_veterinarian_name}}</div>
        </td>
        <td class="content">
          {{row.prevention_content}}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: ['yobouLog'],
  mounted() {
    console.log(this.$props.healthCheckLog)
  }
}
</script>

<style scoped>
td:not(.content) {
  width: 15%;
}
td.content {}
td.content div {
  font-weight: normal;
  font-size: 0.9rem;
}
</style>